module.exports = __webpack_public_path__ + "img/72.cab3840a.png";